import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import qs from 'query-string';

import { userSelectors } from 'reducers';
import { iFrameKey, queryStringifyOptions } from 'utils/constants';
import { inIframe } from 'utils/helpers';

import { BigLoader } from 'components';
import { LoggingRedirect } from 'routes/Routes';

const TunnelIframe = () => {
    const loggedIn = useSelector(userSelectors.getLoggedInStatus);
    const location = useLocation();
    const params = qs.parse(location.search, queryStringifyOptions);

    useEffect(() => {
        if (location.pathname.includes('error')) {
            window.parent.postMessage(
                JSON.stringify({ payload: { privateKey: iFrameKey, value: 'error', params } }),
                window.location.origin
            );
        }
        if (location.pathname.includes('success')) {
            window.parent.postMessage(
                JSON.stringify({ payload: { privateKey: iFrameKey, value: 'success', params } }),
                window.location.origin
            );
        }
    }, [location, params]);

    if (!inIframe()) {
        return <LoggingRedirect origin="TUNNEL_IFRAME" to={loggedIn ? 'sign-up' : 'sign-in'} />;
    }

    return <BigLoader />;
};

export default TunnelIframe;
